import React from 'react';
import { cn } from '~/lib/utils';

interface ContainerProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  as?: 'div' | 'section' | 'article' | 'main';
  size?: 'default' | 'narrow' | 'wide';
  padding?: 'default' | 'large' | 'none';
}

export function Container({
  children,
  as: Component = 'div',
  size = 'default',
  padding = 'default',
  className,
  ...props
}: ContainerProps) {
  return (
    <Component
      className={cn(
        'mx-auto w-full',
        {
          'max-w-6xl': size === 'default',
          'max-w-4xl': size === 'narrow',
          'max-w-7xl': size === 'wide',
        },
        {
          'px-4 sm:px-6 lg:px-8': padding === 'default',
          'px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-24': padding === 'large',
          'px-0': padding === 'none',
        },
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export function Section({ children, className, ...props }: SectionProps) {
  return (
    <section
      className={cn('py-12 md:py-16 lg:py-24', className)}
      {...props}
    >
      {children}
    </section>
  );
}
